module.exports = __webpack_public_path__ + "img/emirates_logo.608675c3.svg";